import { render, staticRenderFns } from "./TotemJourneys.vue?vue&type=template&id=401fe9b5"
import script from "./TotemJourneys.vue?vue&type=script&lang=js"
export * from "./TotemJourneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports